import React, {useEffect, useState, useCallback} from "react";
import {createUseStyles, useTheme} from "react-jss";
import TabNav from "@artibulles-cis/react/TabNav";

import AccountingDashboard from "./AccountingDashboard";
import AccountsBank from "./AccountsBank";

//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    ClassExtendTabNavLink: {
        borderRight: "1px solid rgb(220 220 220)",
    },
}));

const Component = React.memo(function Component(props) {
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** REFS ******************/

    /***************** REFS ******************/

    /***************** CONST ******************/

    /***************** CONST ******************/

    /***************** STATE ******************/

    /***************** STATE ******************/

    /***************** CALLBACK ******************/

    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/

    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/

    return (
        <TabNav
            MainSlug={`/financials/accounting/dashboard`}
            DefaultTab={`/financials/accounting/dashboard/main`}
            ClassExtendTabNavLink={classes.ClassExtendTabNavLink}
            TabNavMenuHeight="30px"
            ActiveIndicator={{
                WithIndicator: true,
                Position: "Bottom",
            }}
            TabMenuContent={[
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Main</div>
                        </div>
                    ),
                    Slug: `/financials/accounting/dashboard/main`,
                    ShowOnlyIfActive: false,
                    exact: true,
                    TabContent: <AccountingDashboard />,
                },
				{
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>check</div>
                        </div>
                    ),
                    Slug: `/financials/accounting/dashboard/check`,
                    ShowOnlyIfActive: false,
                    exact: true,
                    TabContent: <AccountsBank />,
                }
            ]}
			
        />
    );

    /***************** RENDER ******************/
});

export default Component;
